import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Link from '@mui/material/Link';

export const ActionsContainer = styled(Box)(() => ({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'flex-end',
  width: '100%',
}));

export const StyledLink = styled(Link)(({ theme }) => ({
  '&.MuiLink-root:focus': {
    outline: 'none',
  },
  '&.MuiLinkBase-root, &.MuiLink-root': {
    fontSize: theme.typography.fontSize,
    fontWeight: theme.typography.fontWeightRegular,
    padding: 0,
    textTransform: 'none',
  },
}));

export const StyledModalContent = styled(Box)(() => ({
  lineHeight: '24px',
  maxHeight: '75vh',
  minHeight: '100px',
  overflowX: 'scroll',
  overflowY: 'auto',
}));

export const StyledDialog = styled(Dialog)(() => ({
  '& .MuiPaper-root': {
    boxShadow: 'none',
  },
}));

export const StyledModalDialogContent = styled(DialogContent)(() => ({
  paddingTop: '0px !important',
}));
